import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold font-heading text-background-50 mb-4">韩漫网</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫网拥有好看的韩国漫画大全，实现韩国漫画全集免费看，专属下拉式模式让韩漫在线阅读更轻松。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">恋爱韩漫</Link>
              <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">奇幻韩漫</Link>
              <Link to="/category/action" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">动作韩漫</Link>
              <Link to="/category/thriller" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">悬疑韩漫</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@hanmanwang.com</span>
              <span>客服QQ：1234567890</span>
              <span>工作时间：周一至周日 9:00-22:00</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫网 - 韩国漫画全集免费在线阅读平台
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}